import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import { useSetHighestZIndexToNode } from 'components/canvas/hooks/use-set-heighest-z-index-to-node';
import useMutation from 'hooks/use-mutation';
import { createSurfaceTextNodeMutation } from 'graphql/surface-node/mutations/surface-text-node/create-surface-text-node';
import { updateSurfaceTextNodeMutation } from 'graphql/surface-node/mutations/surface-text-node/update-surface-text-node';
import { isArray, pick } from 'lodash';
import { flow, set } from 'lodash/fp';
import { toast } from 'services/toast';

export default function useSaveSurfaceTextNode() {
  const saveNodeInCache = useSaveNodeInCache();
  const setHighestZIndexToNode = useSetHighestZIndexToNode();

  const [createSurfaceNode] = useMutation(createSurfaceTextNodeMutation);

  const [updateSurfaceNode] = useMutation(updateSurfaceTextNodeMutation);

  return function saveSurfaceTextNode(params) {
    const isUpdate = params.variables.input?.id;

    parseSnippets(params);

    params = parseSlateData(params);

    if (isUpdate) {
      params.variables.input = pick(params.variables.input, [
        'id',
        'name',
        'text',
        'slateData',
        'snippets',
      ]);

      return updateSurfaceNode(params).then((response) => {
        if (response.isFailure) {
          toast.error(response.getErrorMessage());

          return response;
        }

        saveNodeInCache(response.getField('data'));

        return response;
      });
    }

    params.variables.input = pick(params.variables.input, [
      'name',
      'text',
      'slateData',
      'surface',
      'position',
      'snippets',
    ]);

    return createSurfaceNode(params).then((response) => {
      if (response.isFailure) {
        toast.error(response.getErrorMessage());

        return response;
      }

      saveNodeInCache(response.getField('data'));
      setHighestZIndexToNode(response.getField('data'));
      return response;
    });
  };
}

function parseSlateData(params) {
  const slateData = params.variables.input.slateData?.data;

  return flow(
    set(
      'variables.input.slateData',
      isArray(slateData) ? JSON.stringify(slateData) : slateData,
    ),
    set('variables.input.text', params.variables.input.slateData?.text),
  )(params);
}

function parseSnippets(params) {
  if (params.variables?.input?.snippets) {
    params.variables.input.snippets = params.variables?.input?.snippets?.map(
      (snippet) =>
        pick(snippet, ['id', 'annotationId', 'name', 'text', 'operation']),
    );
  }
}
